export const getFormDataFromObject = (obj: object, changeArray = true) => {
    const formData = new FormData()
    Object.entries(obj).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            if (Array.isArray(value) && (changeArray || key === 'photos')) {
                value.forEach(item => formData.append(`${key}`, key === 'photos' ? item : JSON.stringify(item)))
            } else if (typeof value === 'string' || value instanceof File) {
                formData.append(key, value)
            } else {
                formData.append(key, typeof value === 'boolean' ? Number(value).toString() : JSON.stringify(value))
            }
        }
    })

    return formData
}
